import React, { Component } from 'react';
import { LuBadgeInfo, LuEye, LuFileEdit, LuTrash2, LuEyeOff } from 'react-icons/lu';
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { PatientDeleteRes, PatientDeleteTodo } from 'redux/slice/admin/patient/DeletePatient';
// import { DeleteDoctorRes, DeleteDoctorTodo } from 'redux/slice/admin/doctor/DeleteDoctor';

class PatientListAction extends Component {
    constructor(props) {
        super(props);
        this.edit_doctor = this.edit_doctor?.bind(this);
        this.del_doctor = this.del_doctor?.bind(this);
        this.del_res = this.del_res?.bind(this);
    }



    edit_doctor() {
        this.props.history.push('../admin/update-patient', { state: this.props.data });
    
    }

    del_doctor() {
        const { dispatch, data } = this.props;
        Swal.fire({
            title: "Patient Delete",
            text: "Are You Sure Want To Delete This Patient?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Delete'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(PatientDeleteTodo(data.id)).then(() => this.del_res());
            }
        });
    }

    del_res() {
        const { bool, setBool } = this.props;
        if (PatientDeleteRes?.success) {
            setBool(!bool); 
            Swal.fire(
                "Patient",
                'Patient Deleted Successfully',
                'success'
            );
        } else {
            toast.error(PatientDeleteRes?.message, { position: "bottom-right" });
        }
    }

    render() {
        return (
            <div>
                <LuFileEdit size={20} className='edit text-success ms-3'
                    onClick={this.edit_doctor}
                    data-tooltip-id='edit'
                    data-tooltip-content="Edit Patient!"
                    data-tooltip-place="bottom"
                />

                <LuTrash2 size={20} className='delete text-danger ms-3'
                    onClick={this.del_doctor}
                    data-tooltip-id='del'
                    data-tooltip-content="Delete Patient!"
                    data-tooltip-place="bottom"
                />

                <Tooltip id='edit' className='bg-success tooltip_msg' />
                <Tooltip id='del' className='bg-danger tooltip_msg' />
                <Tooltip id='details' className='bg-primary tooltip_msg' />
                <Tooltip id='active' className='bg-secondary tooltip_msg' />
                <Tooltip id='deactivate' className='bg-secondary tooltip_msg' />
            </div>
        );
    }
}

export default withRouter(connect()(PatientListAction));

